const E="NONE",I="FILL_WINDOW",N="KEEP_ASPECT",O="AUTO",o="FIXED";export{I as FILLMODE_FILL_WINDOW,N as FILLMODE_KEEP_ASPECT,E as FILLMODE_NONE,O as RESOLUTION_AUTO,o as RESOLUTION_FIXED};
